import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
  selector: 'app-intrested-price',
  templateUrl: './intrested-price.component.html',
  styleUrls: ['./intrested-price.component.scss']
})
export class IntrestedPriceComponent implements OnInit {
  interestedPrice: string = 'PRODUCT';
  btn: any = "Pending"
  headingName:any ='Intrested Price'
  linkerRouteItems:any =[
    { name:'Home',route: '/home'},
   
    {name:'Intrested Price',route:'/customer-order-history'}
  ]

  orderList: any =[]
  count: any
  catName: any
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING'
  isLoading: boolean = false;
  notFoundData:boolean =false
  constructor(public commonService: CommonService, public router: Router) { }

  ngOnInit(): void {
    this.serviceOrderList('PRODUCT');
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }

  serviceOrderList(e) {
    this.isLoading =true
    this.orderList =[];
    this.count= 0;
    const data = {
      page: String(this.currentPage),
      limit: String(this.pageSize),
      campaignOn : e
    }
    this.commonService.postApi('campaign/getIntrestedPriceList', data, 1).subscribe((res: any) => {
      this.isLoading =false
      if (res['responseCode'] == 200 && res.result.docs.length>0) {
        this.commonService.hideSpinner()
        this.orderList = res.result.docs;
        this.count = res.result.total
        if(this.orderList.length>0){
          this.notFoundData =false
        }else{
          this.notFoundData =true
        }
      }else{
        this.commonService.hideSpinner()
        this.notFoundData =true
        this.commonService.errorToast(res.responseMessage)
      }

    }, (err: any) => {
      this.notFoundData =true
      this.isLoading =false
      if (err.responseCode == 409) {
        this.commonService.hideSpinner()
        this.commonService.errorToast(err.responseMessage)
      }
    })
  }

  changePageNumber(page) {
    this.currentPage = page;
    this.serviceOrderList(this.interestedPrice);
  }
  getNoOfquantity(prodArr){
    let noOfQuant = 0
    for (const item of prodArr) {
      noOfQuant += item.quantity
    }
    return noOfQuant
  }
  tabChange(e){
    this.currentPage = 1
    this.serviceOrderList(this.interestedPrice);
  }
}
